import {Box,Typography} from "@mui/material";

export default function OurProductFeatures({ children, title, text}) {
  return (
        <Box  sx={{  background:"#00003D", padding:2, borderRadius:"25px"  }} >
            <Box sx={{display:"flex", justifyContent:"space-between",my:2, gap:1, alignItems:"center"}}>
            <Typography variant="h5" sx={{color:"#ffffff", fontSize:20, fontWeight:"bold"}} gutterBottom>
                {title}
            </Typography>
            <Box sx={{background:"#ffd00a",color:"#00003D", fontWeight:"bold", borderRadius:"50px", width:"50px",height:"50px", display:"flex", justifyContent:"center", alignItems:"center"}}>
                {children}
            </Box>
            

            </Box>
            <Typography  variant="body1" sx={{display:"flex", color:"#ffffff", textAlign:"justify",fontSize:15}}>
            {text}
            </Typography>
        </Box>
            
    )
}
